<template>
  <div class="filters">
    <h1>Project Filters</h1>
    <ProjectFilterForm
      v-for="filter in project.filters"
      :key="filter.key"
      :filter="filter"
      @delete-filter="deleteFilter"
    />
  </div>
</template>

<script>
import ProjectFilterForm from '@/components/project/ProjectFilterForm';

export default {
  name: 'ProjectFilters',
  props: ['project'],
  components: {
    ProjectFilterForm
  },
  methods: {
    deleteFilter(filterToDelete) {
      if(confirm(`Are you sure you want to delete this the filter "${filterToDelete.name}"?`))
        this.project.filters = this.project.filters.filter((projectFilter) => filterToDelete.name !== projectFilter.name)
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/input';
@import '../../assets/styles/card';

.filters {
  margin: 16px 0;
  padding-top: 16px;
  border-top: 1px solid $primary-shadow;
}

h1 {
  padding-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/project/ProjectFilters.vue